import { useState } from "react";
import Header from "../../components/Header";
import PageContainer from "../../components/PageContainer";
import Sidebar from "../../components/Sidebar";
// import DeleteButton from "../../components/actions/DeleteButton";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
//import { deleteService } from "../../services/deleteService";
import toast, { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import Breadcrumbs from "../../components/Breadcrumbs";
import FirmFlowTable from "../../components/mytasks/FirmFlowTable";
import { cloneService } from "../../services/cloneService";
import { DeleteService } from "../../services/service/deleteService";
import { getServicesByDepartment } from "../../services/service/getServicesByDepartment";
import DeleteServiceModal from "./DeleteServiceModal";
import { usePermissions } from "../../context/PermissionsContext";

function ServicesByDepartment() {
    const { can } = usePermissions();
    const params = useParams();
    const navigate = useNavigate();
    const [serviceIdToBeDeleted, setServiceIdToBeDeleted] = useState("");
    const [selectedServiceTemplate, setSelectedServiceTemplate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const noPermissionMessage = "You don't have permission to do this.";
    const canReadDepartments =
        can("departments.read") ||
        can("departments.write") ||
        can("departments.delete");
    const canReadServices =
        can("services.read") || can("services.write") || can("services.delete");
    const canWriteServices = can("services.write");
    const canDeleteServices = can("services.delete");

    //Set initial list
    useEffect(() => {
        if (!canReadDepartments || !canReadServices) {
            setLoading(false);
            return;
        }

        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canReadDepartments, canReadServices]);

    const callApi = async () => {
        const res = await getServicesByDepartment(params.name);
        console.log(res.data);
        //Setting list, pagination labels, and client name
        /*  res.data.map((item) => {
      item.updated = new Date(item.updated).toDateString().substring(4);
    }); */
        setList(res.data.services);
        // setPagination({ firstIndex: 1, lastIndex: res.data.length, totalResults: res.data.length });
        setLoading(false);
    };

    const _cloneService = async (service_id) => {
        if (!canWriteServices) {
            toast.error("You don't have permission to do this");
            return;
        }
        console.log("test");
        const res = await cloneService(service_id);

        if (res.data.success) {
            callApi();
        }
    };

    const [tooltip, showTooltip] = useState(true);

    const handleOpenDeleteModal = (template) => {
        if (!canDeleteServices) {
            toast.error("You don't have permission to do this");
            return;
        }
        setSelectedServiceTemplate(template);
        setIsModalOpen(true);
        setServiceIdToBeDeleted(template?.id);
    };

    const onRemoveService = async (serviceId = serviceIdToBeDeleted) => {
        const response = await DeleteService(serviceId);
        if (response.success) {
            console.log(response);
            toast.success(response.data.message);
            callApi();
        } else {
            toast.error(response.data.message);
        }
        setIsModalOpen(false);
    };

    return (
        <section>
            <Toaster />
            <DeleteServiceModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                onRemoveService={() =>
                    onRemoveService(selectedServiceTemplate?.id)
                }
                serviceTemplate={selectedServiceTemplate}
            />
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <PageContainer
                        isLoading={loading}
                        loadingText="Loading services..."
                    >
                        <main>
                            <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                                <Breadcrumbs
                                    home="/departments"
                                    pages={[
                                        {
                                            name: "Services",
                                            href: `#`,
                                            current: true,
                                        },
                                    ]}
                                />
                                {/* Page header */}
                                <div className="mb-8 sm:flex sm:justify-between sm:items-center">
                                    {/* Left: Title */}
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                            Services
                                        </h1>
                                    </div>

                                    {/* Right: Actions */}
                                    <div className="grid items-end justify-start grid-flow-col gap-2 sm:auto-cols-max sm:justify-end">
                                        {/* Add service button */}
                                        <span
                                            data-tip={
                                                canWriteServices
                                                    ? "Add Service"
                                                    : noPermissionMessage
                                            }
                                            className="inline-flex"
                                        >
                                            <button
                                                onClick={() =>
                                                    navigate(
                                                        "/templates/services/create",
                                                    )
                                                }
                                                disabled={!canWriteServices}
                                                className={`h-10 text-white bg-teal-500 btn ${
                                                    canWriteServices
                                                        ? "hover:bg-teal-600"
                                                        : "opacity-50 cursor-not-allowed"
                                                }`}
                                            >
                                                <svg
                                                    className="w-4 h-4 opacity-50 fill-current shrink-0"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                                <span className="ml-2 xs:block">
                                                    Add Service Template
                                                </span>
                                            </button>
                                        </span>
                                        {/* Clone button */}
                                        {/* <button onClick={() => clone()} className="h-10 text-white bg-teal-500 btn hover:bg-teal-600">
                      <svg className="w-4 h-4 opacity-50 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="ml-2 xs:block">Clone Service Template</span>
                    </button> */}
                                    </div>
                                </div>

                                {canReadDepartments && canReadServices ? (
                                    <FirmFlowTable
                                    columns={[
                                        {
                                            Header: "Name",
                                            accessor: "name",
                                            Cell: (props) => (
                                                <>
                                                    {tooltip && (
                                                        <ReactTooltip
                                                            type="light"
                                                            effect="solid"
                                                            place="top"
                                                            border={true}
                                                            borderColor={
                                                                "rgb(220,220,220)"
                                                            }
                                                            className="rounded-md bg-gray-50"
                                                            multiline={false}
                                                        />
                                                    )}
                                                    <button
                                                        onMouseEnter={() =>
                                                            showTooltip(true)
                                                        }
                                                        onMouseLeave={() => {
                                                            showTooltip(false);
                                                        }}
                                                        data-tip={`Template for ${props.row.original.name}`}
                                                        onClick={() =>
                                                            navigate(
                                                                `/services/${props.row.original.id}`,
                                                            )
                                                        }
                                                        className="rounded-full text-gray hover:text-blue-500"
                                                    >
                                                        {props.row.original.name}
                                                    </button>
                                                </>
                                            ),
                                        },
                                        {
                                            Header: "Department",
                                            accessor: "department",
                                            Cell: (props) => (
                                                <a
                                                    rel="noreferrer"
                                                    href={`/services/${props.row.original.id}`}
                                                    className="rounded-full text-gray hover:text-blue-500"
                                                >
                                                    {props.value}
                                                </a>
                                            ),
                                        },
                                        /*  {
                      Header: "Update On",
                      accessor: "updated",
                    }, */
                                        {
                                            Header: "Actions",
                                            accessor: "id",
                                            Cell: (props) => (
                                                <td
                                                    onMouseEnter={() =>
                                                        showTooltip(true)
                                                    }
                                                    onMouseLeave={() => {
                                                        showTooltip(false);
                                                    }}
                                                    className="w-px px-2 py-3 first:pl-5 last:pr-5 whitespace-nowrap"
                                                >
                                                    {tooltip && (
                                                        <ReactTooltip
                                                            type="light"
                                                            effect="solid"
                                                            place="top"
                                                            border={true}
                                                            borderColor={
                                                                "rgb(220,220,220)"
                                                            }
                                                            className="rounded-md bg-gray-50"
                                                            multiline={false}
                                                        />
                                                    )}
                                                    {/* Menu button */}
                                                    <button
                                                        data-tip="Edit"
                                                        disabled={!canWriteServices}
                                                        onClick={() =>
                                                            navigate(
                                                                `/services/${props.value}`,
                                                            )
                                                        }
                                                        className={`rounded-full ${
                                                            canWriteServices
                                                                ? "text-slate-400 hover:text-slate-500"
                                                                : "text-slate-300 cursor-not-allowed"
                                                        }`}
                                                    >
                                                        <span className="sr-only">
                                                            Menu
                                                        </span>
                                                        <svg
                                                            className="w-8 h-8 fill-current"
                                                            viewBox="0 0 32 32"
                                                        >
                                                            <circle
                                                                cx="16"
                                                                cy="16"
                                                                r="2"
                                                            />
                                                            <circle
                                                                cx="10"
                                                                cy="16"
                                                                r="2"
                                                            />
                                                            <circle
                                                                cx="22"
                                                                cy="16"
                                                                r="2"
                                                            />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        data-tip="Duplicate"
                                                        disabled={!canWriteServices}
                                                        onClick={() =>
                                                            _cloneService(
                                                                props.value,
                                                            )
                                                        }
                                                        className={
                                                            canWriteServices
                                                                ? ""
                                                                : "cursor-not-allowed opacity-60"
                                                        }
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="p-1 pt-0 w-7 h-7 text-slate-400 hover:text-slate-500"
                                                        >
                                                            <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 013.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0121 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 017.5 16.125V3.375z" />
                                                            <path d="M15 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0017.25 7.5h-1.875A.375.375 0 0115 7.125V5.25zM4.875 6H6v10.125A3.375 3.375 0 009.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V7.875C3 6.839 3.84 6 4.875 6z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        data-tip="Delete"
                                                        disabled={!canDeleteServices}
                                                        onClick={() =>
                                                            handleOpenDeleteModal(
                                                                props.row.original,
                                                            )
                                                        }
                                                        className={
                                                            canDeleteServices
                                                                ? ""
                                                                : "cursor-not-allowed opacity-60"
                                                        }
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="p-1 pt-0 w-7 h-7 text-slate-400 hover:text-red-500"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    </button>
                                                </td>
                                            ),
                                        },
                                    ]}
                                    data={list}
                                />
                                ) : canReadDepartments ? (
                                    <div className="p-4 text-sm border rounded-sm border-slate-200 text-slate-600">
                                        You don't have permission to view services.
                                    </div>
                                ) : (
                                    <div className="p-4 text-sm border rounded-sm border-slate-200 text-slate-600">
                                        You don't have permission to view departments.
                                    </div>
                                )}
                            </div>
                        </main>
                    </PageContainer>
                </div>
            </div>
        </section>
    );
}
export default ServicesByDepartment;
